<template>
  <div class="container-size" style="overflow-x: hidden">
    <popup :message="alertErrMessage" v-if="isAlertErr" :isError="isError" @close="isAlertErr = false" />
    <div class="mainContainer">
      <img style="" src="/img/corporate/talent-service/main.png" alt="" />
      <h1>{{ $t('talentService.heroSection.title') }}</h1>
      <p>{{ $t('talentService.heroSection.description') }}</p>
      <div class="tombol">
        <button class="konsultasi" @click="scrollToSection('collab')">
          {{ $t('talentService.heroSection.ctaButtons.collaborateNow') }}
        </button>
        <button class="hubungi" @click="sendToWa">{{ $t('talentService.heroSection.ctaButtons.contactUs') }}</button>
      </div>
    </div>
    <div class="banner-content">
      <h3 style="padding: 10px" class="text-center">
        {{ $t('talentService.trustedPartners.title') }}
      </h3>
      <div class="marquee-container">
        <div class="marquee-wrapper">
          <div class="our-client">
            <img v-for="(item, idx) in ourClients" :key="idx" :src="item.img_url_mobile" class="image-client" />
          </div>
        </div>
        <div class="marquee-wrapper">
          <div class="our-client">
            <img v-for="(item, idx) in ourClients" :key="idx" :src="item.img_url_mobile" class="image-client" />
          </div>
        </div>
      </div>
      <h3 class="mt-10 text-center">
        {{ $t('talentService.services.title') }}
      </h3>
      <p class="m-auto mb-5" style="text-align: center; font-size: 12px">
        {{ $t('talentService.services.description') }}
      </p>
      <div class="benefit-container">
        <div class="benefits" v-for="(item, idx) in benefits" :key="idx">
          <div class="benefit-item">
            <img :src="item.icon" width="60" height="60" alt="" style="border-radius: 100%" />
            <h4>{{ $t(`talentService.products.${idx}.title`) }}</h4>
            <p>{{ $t(`talentService.products.${idx}.desc`) }}</p>
          </div>
        </div>
      </div>
      <div class="bg-linear">
        <div class="layanan-requirement">
          <h1 class="mb-8 pt-10 text-center" style="font-size: 22px">
            {{ $t(`talentService.a5`) }}
          </h1>
          <div style="padding-bottom: 30px" class="layanan-requirement-card">
            <div class="card-list" v-for="(data, idx) in trainData" :key="idx">
              <div class="icon">
                <components :is="data.icon"></components>
              </div>
              <h2 class="text-center">{{ $t(`talentService.trainData.${idx}.name`) }}</h2>
              <p style="font-size: 14px;">{{ $t(`talentService.trainData.${idx}.desc`) }}</p>
              <h3 class="mt-5">{{ $t(`talentService.trainData.${idx}.quest`) }}</h3>
              <ul>
                <li v-for="(data2, idx2) in $t(`talentService.trainData.${idx}.list`)" :key="idx2"
                  style="font-size: 14px;">{{ data2 }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="why-hicol">
        <h3 class="mt-10 text-center mb-3">{{ $t('talentService.whyChoose.title') }}</h3>
        <p style="text-align: center; font-size: 12px" v-html="$t('talentService.whyChoose.description')"></p>
        <div class="card mb-5" style="
            object-fit: cover;
            width: 100%;
            height: 350px;
            display: block;
            overflow: hidden;
            padding: 0;
            border-radius: 30px;
          ">
          <img src="/img/corporate/talent-service/main2.png" style="width: 100%" alt="" />
        </div>
        <div class="why-item mb-5" style="margin-bottom: 20px" v-for="(item, idx) in whyhicol" :key="idx">
          <div :style="idx < whyhicol.length - 1
            ? 'border-bottom: 1px solid #acafbf; padding-bottom: 30px;'
            : 'padding-bottom: 0px;'
            ">
            <components :is="item.icon"></components>
            <h4>{{ $t(`talentService.usp.${idx}.title`) }}</h4>
            <p class="mt-2 text-justify" style="font-size: 12px">
              {{ $t(`talentService.usp.${idx}.desc`) }}
            </p>
          </div>
        </div>
      </div>
      <div style="
          background-color: #f1f6ff;
          border-radius: 18px;
          padding-bottom: 50px;
        ">
        <div class="collaboratif">
          <h5>{{ $t('talentService.a8') }}</h5>
          <div class="desc">
            <div class="card-content" v-for="(data, index) in $t('talentService.steps')" :key="index">
              <div class="card-img">
                <img :src="data.image_url" width="300" alt="" style="margin-top: -20px" />
              </div>
              <div class="desc">
                <h3>{{ data.title }}</h3>
                <p>{{ data.description }}</p>
              </div>
            </div>
          </div>
          <div class="indicator-container">
            <div style="width: 10px; height: 10px"></div>
            <div class="indicator">
              <svg :style="{ transform: `translateX(${indicator * 15}px)` }" width="25" height="10" viewBox="0 0 25 10"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="25" height="10" rx="5" fill="#162CA2" />
              </svg>
              <svg :style="{ transform: `translateX(${-indicator2 * 30}px` }" width="10" height="10" viewBox="0 0 10 10"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="5" cy="5" r="5" fill="#7B7E8C" />
              </svg>
              <svg :style="{ transform: `translateX(${-indicator3 * 30}px` }" width="10" height="10" viewBox="0 0 10 10"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="5" cy="5" r="5" fill="#7B7E8C" />
              </svg>
            </div>

            <div class="btn-arrow">
              <div class="btn-card">
                <img src="/img/other/corporate-arrow-left.png" alt="" @click="scrollLeftStep" />
              </div>
              <div class="btn-card">
                <img src="/img/other/corporate-arrow-right.png" alt="" @click="scrollRightStep" />
              </div>
            </div>
          </div>
        </div>
        <h3 class="text-center mt-6">{{ $t('talentService.a6') }}</h3>
        <div class="partner" style="width: 100% !important">
          <div class="card" style="overflow-x: none !important">
            <div v-for="(partner, index) in ocupation1" :key="index">
              <div class="logo-card-partner-3" style="width: max-content">
                <div class="box-1">
                  <div><img :src="partner.img" alt="" /></div>
                  <span>{{ partner.title }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="partner" style="width: 100% !important">
          <div class="card" style="overflow-x: none !important">
            <div v-for="(partner, index) in ocupation2" :key="index">
              <div class="logo-card-partner-2" style="width: max-content">
                <div class="box-1">
                  <div><img :src="partner.img" alt="" /></div>
                  <span>{{ partner.title }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="partner" style="width: 100% !important">
          <div class="card" style="overflow-x: none !important">
            <div v-for="(partner, index) in ocupation3" :key="index">
              <div class="logo-card-partner-3" style="width: max-content">
                <div class="box-1">
                  <div><img :src="partner.img" alt="" /></div>
                  <span>{{ partner.title }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin: 40px 30px 0px 30px">
          <Button :name="$t('talentService.a7')" width="100%" @click="() => scrollToSection('collab')" />
        </div>
      </div>
      <div class="form-konsultasi mt-10">
        <div class="header text-center">
          <h2 style="margin: 0;">{{ $t('talentService.formSection.title') }}</h2>
        </div>
        <div class="sub-heading mt-2 text-center">
          <p style="font-size: 12px; margin: 0;">
            {{ $t('talentService.formSection.subTitle') }}
          </p>
          <v-form class="text-start" style="margin-top: 60px" id="collab">
            <div>
              <label class="form-label" for="company">{{ $t('talentService.formSection.labels.companyName') }}<span
                  style="color: rgba(184, 15, 10, 1)">*</span></label>
              <v-text-field class="form-input text-form" name="company" v-model="form.corporate_name" outlined
                :placeholder="$t('talentService.formSection.placeholders.companyName')"
                :full-width="true"></v-text-field>
            </div>
            <div>
              <label class="form-label" for="website">{{ $t('talentService.formSection.labels.website') }}<span
                  style="color: rgba(184, 15, 10, 1)">*</span></label>
              <v-text-field class="form-input text-form" v-model="form.web_url" name="website" outlined
                :placeholder="$t('talentService.formSection.placeholders.website')"></v-text-field>
            </div>

            <div>
              <label class="form-label" for="pic-name">{{ $t('talentService.formSection.labels.picName') }}<span
                  style="color: rgba(184, 15, 10, 1)">*</span></label>
              <v-text-field class="form-input text-form" name="pic-name" v-model="form.full_name" outlined
                :placeholder="$t('talentService.formSection.placeholders.picName')"></v-text-field>
            </div>
            <div>
              <label class="form-label" for="email">{{ $t('talentService.formSection.labels.email') }}<span
                  style="color: rgba(184, 15, 10, 1)">*</span></label>
              <v-text-field class="form-input text-form" name="email" outlined v-model="form.email"
                :placeholder="$t('talentService.formSection.placeholders.email')" max-width></v-text-field>
            </div>

            <div>
              <label class="form-label" for="occupation">{{ $t('talentService.formSection.labels.occupation') }}</label>
              <v-text-field class="form-input text-form" name="occupation" outlined v-model="form.job_pic"
                :placeholder="$t('talentService.formSection.placeholders.occupation')">
              </v-text-field>
            </div>
            <div>
              <label class="form-label" for="phone-number">{{ $t('talentService.formSection.labels.phoneNumber') }}<span
                  style="color: rgba(184, 15, 10, 1)">*</span></label>
              <v-text-field class="form-input text-form" name="phone-number" outlined
                :placeholder="$t('talentService.formSection.placeholders.phoneNumber')" v-model="form.phone_number"
                type="number" hide-spin-buttons>
                <template v-slot:prepend-inner>
                  <img src="/img/other/flag-indonesia.png" alt="" width="30" height="20"
                    style="box-shadow: 2px 2px 3px 1px rgba(13, 28, 113, 0.1)" />
                  <span style="color: #575966" class="mx-3">+62</span>
                </template>
              </v-text-field>
            </div>
            <v-col cols="12">
              <label class="form-label" for="collaboration">{{ $t('talentService.formSection.labels.collaborationType')
              }}</label>
              <v-text-field class="form-input text-form" solo flat background-color="rgba(247, 249, 253, 1)"
                :placeholder="$t('talentService.formSection.placeholders.collaborationType')" disabled />
            </v-col>
            <div class="mt-3" style="width: 80%; margin: auto;">
              <v-checkbox class="form-input custom-checkbox" v-model="is_confirm">
                <template v-slot:label>
                  <h5 class="label-checkbox" v-html="$t('talentService.formSection.labels.confirmCheckbox')"></h5>
                </template>
              </v-checkbox>
            </div>
            <v-row class="d-flex justify-center align-center mt-6">
              <v-btn elevation="0" :class="`btn-kirim ${is_confirm ? 'confirm' : 'reject'}`" @click="onSubmit">{{
                $t('talentService.formSection.buttons.submit') }}
              </v-btn>
            </v-row>
          </v-form>
        </div>
      </div>
    </div>

    <div class="faq" style="margin-top: 10px">
      <div class="content">
        <div class="row">
          <div class="col-lg-3">
            <div class="header">
              <h3 class="text-center">Frequently Asked Question</h3>
            </div>
          </div>
          <div class="container">
            <AccordeonFaq v-for="(item, index) in questions" :key="index" :title="item.title"
              :description="item.description" :active="item.active" @toggle="toggleAccordion(index, item.title)" />
          </div>
          <div class="btn-stoke-blue cursor-pointer mt-5" @click="goToFaq">
            <span class="font-poppins">{{ $t('corpAceleration.faqSection.viewMore') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Arrow from "@/assets/icons/Arrow.vue";
import Popup from "@/components/others/Popup.vue";
import PeopleTrain from "@/assets/icons/corporate/PeopleTrain.vue";
import CardTrain from "@/assets/icons/corporate/CardTrain.vue";
import M1Talent from "@/assets/icons/corporate/M1Talent.vue";
import M2Talent from "@/assets/icons/corporate/M2Talent.vue";
import M3Talent from "@/assets/icons/corporate/M3Talent.vue";
import M4Talent from "@/assets/icons/corporate/M4Talent.vue";
import M5Talent from "@/assets/icons/corporate/M5Talent.vue";
import M6Talent from "@/assets/icons/corporate/M6Talent.vue";
import Button from "../../../others/Button.vue";
import AccordeonFaq from "@/components/AccordeonFaq.vue";

export default {
  name: "TalentAsServiceMobile",
  components: {
    Arrow,
    Popup,
    PeopleTrain,
    CardTrain,
    Button,
    AccordeonFaq,
    M1Talent,
    M2Talent,
    M3Talent,
    M4Talent,
    M5Talent,
    M6Talent,
  },
  data() {
    return {
      model: 0,
      trainData: [
        {
          icon: CardTrain,
          name: "IT Outsourcing",
          desc: "Kami menyediakan dan mengelola talenta digital dengan beragam level dan role position di bidang teknologi digital yang siap mendukung optimasi dan produktivitas bisnis perusahaan Anda",
          quest: "Mengapa pilih IT Outsourcing?",
          list: [
            "Perusahaan dapat fokus melakukan aktivitas bisnis utama",
            "Perusahaan tidak perlu menyediakan fasilitas dan tunjangan",
            "Perusahaan akan mendapatkan talenta digital yang berkualitas",
            "Perusahaan tidak perlu repot melakukan proses rekrutmen",
            "Menghemat Biaya Operasional Signifikan",
            "Akses Talenta Digital dan Teknologi Baru",
          ],
        },
        {
          icon: PeopleTrain,
          name: "IT Head Hunting",
          desc: "Kami menyediakan layanan perekrutan dan menemukan talenta digital berkualitas serta profesional melalui mekanisme perekrutan yang kompatibel dan terstruktur untuk menjawab kebutuhan perusahaan Anda",
          quest: "Mengapa pilih Head Hunting?",
          list: [
            "Efisiensi biaya dan waktu",
            "Identifikasi kandidat yang cocok dengan posisi yang tersedia",
            "Menemukan talenta digital yang kompatibel",
            "Mempercepat proses sourcing dan screening",
            "Mendapatkan garansi pergantian talenta digital sesuai dengan kesepakatan",
          ],
        },
      ],
      benefits: [
        {
          icon: "/img/corporate/talent-service/c1.png",
          title: "Talent Sourcing",
          desc: "Pencarian kandidat potensial secara masif yang selaras kebutuhan mitra dengan didukung metode sourcing dan tim yang memiliki pengalaman dengan akses database talenta terlengkap.",
        },
        {
          icon: "/img/corporate/talent-service/c2.png",
          title: "Talent Screening",
          desc: "Proses screening yang komprehensif demi menjaring talenta digital terbaik melalui aspek kompetensi teknis, pengalaman relevan, motivasi, budaya kerja, serta kecocokan dengan deskripsi pekerjaan.",
        },
        {
          icon: "/img/corporate/talent-service/c3.png",
          title: "Assesment",
          desc: "Pencarian kandidat melalui rangkaian metode asesmen seperti tes keterampilan, wawancara teknis, studi kasus dalam mengukur potensi kandidat sesuai kualifikasi yang dibutuhkan.",
        },
        {
          icon: "/img/corporate/talent-service/c4.png",
          title: "Recommendation",
          desc: "Melalui hasil asesmen, kandidat talenta terbaik akan direkomendasikan sesuai dengan kebutuhan bisnis Anda, disertai profil lengkap, portfolio, dan informasi pendukung lainnya.",
        },
        {
          icon: "/img/corporate/talent-service/c5.png",
          title: "Contract Management",
          desc: "HiColleagues akan menangani seluruh proses kontrak kerja seperti negosiasi kompensasi, penyusunan kontrak, perizinan, onboarding, dan pengelolaan talenta selama masa kontrak sesuai regulasi.",
        },
      ],
      whyhicol: [
        {
          icon: M1Talent,
          title: "Proses Rekrutmen Efisien",
          desc: "Proses rekrutmen dilakukan dengan tepat oleh tim profesional dan didukung metode pencarian kandidat yang komprehensif.",
        },
        {
          icon: M2Talent,
          title: "Jaminan Kepatuhan Regulasi",
          desc: "Kepatuhan regulasi HiColleagues memastikan kepatuhan terhadap semua regulasi dan peraturan ketenagakerjaan yang berlaku.",
        },
        {
          icon: M3Talent,
          title: "Profesionalisme Manajemen",
          desc: "Pengelolaan SDM profesional HiColleagues menangani seluruh aspek pengelolaan SDM seperti penggajian, tunjangan, administrasi, dan lainnya secara profesional.",
        },
        {
          icon: M4Talent,
          title: "Solusi Talenta Digital Fleksibel",
          desc: "Fleksibilitas maksimal dalam penyediaan SDM untuk memperoleh talenta terbaik dengan keterampilan dan skala yang dapat disesuaikan sesuai kebutuhan bisnis Anda.",
        },
        {
          icon: M5Talent,
          title: "Talenta Digital Berkualitas",
          desc: "HiColleagues telah menemukan ribuan talenta digital berkualitas yang berhasil direkrut oleh perusahaan-perusahaan terkemuka di Indonesia.",
        },
        {
          icon: M6Talent,
          title: "Akses Talenta Kompeten",
          desc: "Dapatkan akses ke jaringan talenta profesional yang luas dan terverifikasi di berbagai bidang keahlian.",
        },
      ],
      ourClients: [],
      ocupation1: [
        {
          img: "/img/corporate/talent-service/k1.png",
          title: "Cyber Security",
        },
        {
          img: "/img/corporate/talent-service/k4.png",
          title: "Mobile Developer",
        },
        {
          img: "/img/corporate/talent-service/k9.png",
          title: "System Administrator",
        },
        {
          img: "/img/corporate/talent-service/k12.png",
          title: "Web Developer",
        },
      ],
      ocupation2: [
        {
          img: "/img/corporate/talent-service/k2.png",
          title: "Data Engineer",
        },
        {
          img: "/img/corporate/talent-service/k2.png",
          title: "Database Administrator",
        },
        {
          img: "/img/corporate/talent-service/k5.png",
          title: "Product Manager",
        },
        {
          img: "/img/corporate/talent-service/k11.png",
          title: "Scrum Master",
        },
      ],
      ocupation3: [
        {
          img: "/img/corporate/talent-service/k3.png",
          title: "Data Analyst",
        },
        {
          img: "/img/corporate/talent-service/k8.png",
          title: "Risk Analyst",
        },
        {
          img: "/img/corporate/talent-service/k7.png",
          title: "Quality Assurance",
        },
        {
          img: "/img/corporate/talent-service/k6.png",
          title: "Product Design",
        },
      ],
      questions: [],
      indicator: 0,
      indicator2: 0,
      indicator3: 0,
      sliderIndicator: 0,
      indicatorValue: 0,
      alertErrMessage: "",
      isAlertErr: false,
      is_confirm: false,
      isError: false,
      form: {
        full_name: "",
        email: "",
        phone_number: "",
        gender: "",
        corporate_name: "",
        company_field: "",
        program: "",
        total_student: 0,
        notes: "",
        category: "TALENT_SERVICE",
        web_url: "",
        job_pic: "",
      },
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getFaq();
    },
  },
  methods: {
    toCallWe() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Contact Us - WhatsApp - Talent Service Mobile',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6282127274632&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    async getClientLogo() {
      try {
        const resp = await this.$http.get("/v1/logo?category=TALENT_SERVICE");
        this.ourClients = resp.data.data.logos;
      } catch (err) {
        console.log(err);
      }
    },
    scrollRightStep() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Scroll Right - Collaboration Steps - Talent Service Mobile',
        value: 1,
      });
      const container = this.$el.querySelector(".desc");
      const cardWidth = this.$el.querySelector(".card-content").offsetWidth;
      container.scrollLeft += cardWidth * 1.07;
      if (this.indicator < 2) {
        this.indicator++;
        if (this.indicator2 < 1) {
          this.indicator2++;
        }
      }
      if (this.indicator === 2 && this.indicator3 < 1) {
        this.indicator3++;
      }
    },
    scrollLeftStep() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Scroll Left - Collaboration Steps - Talent Service Mobile',
        value: 1,
      });
      const container = this.$el.querySelector(".desc");
      const cardWidth = this.$el.querySelector(".card-content").offsetWidth;
      container.scrollLeft -= cardWidth * 1.07;
      if (this.indicator === 1) {
        this.indicator2--;
      }
      if (this.indicator > 0) {
        this.indicator--;
      }
      if (this.indicator3 < 2 && this.indicator > 0) {
        this.indicator3--;
      }
    },
    toggleAccordion(index, title) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `Toggle FAQ - ${title} - Talent Service Mobile`,
        value: 1,
      });
      this.questions[index].active = !this.questions[index].active;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=TALENT_SERVICE&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Contact Us - WhatsApp - Talent Service Mobile',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6282127274632&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    scrollToSection(sectionId) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: sectionId === 'collab' ? 'Collaborate Now - Scroll to Form - Talent Service Mobile' : 'Apply Now - Scroll to Form - Talent Service Mobile',
        value: 1,
      });
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    async onSubmit() {
      this.$gtag.event('click', {
        event_category: 'Form',
        event_label: 'Submit Talent Service Form - Mobile',
        value: 1,
      });
      if (!this.is_confirm) {
        return;
      }
      if (
        !this.form.corporate_name ||
        !this.form.full_name ||
        !this.form.job_pic ||
        !this.form.email ||
        !this.form.phone_number ||
        !this.form.category ||
        !this.form.web_url
      ) {
        this.alertErrMessage = "Harap isi semua form yang tersedia";
        this.isAlertErr = true;
        this.isError = true;
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Talent Service Form Submission Error - Mobile',
          value: 0,
        });
        return;
      }
      try {
        await this.$http.post("/v1/corporate-registration", this.form);
        this.alertErrMessage = "Success";
        this.isAlertErr = true;
        this.isError = false;
        this.clearForm();
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Talent Service Form Submission Success - Mobile',
          value: 1,
        });
      } catch {
        this.alertErrMessage = "Error saat submit data";
        this.isAlertErr = true;
        this.isError = true;
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Talent Service Form Submission Error - Mobile',
          value: 0,
        });
      }
    },
    goToFaq() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'View More FAQs - Talent Service Mobile',
        value: 1,
      });
      this.$router.push('/faq');
    },
    clearForm() {
      this.is_confirm = false;
      this.form.full_name = "";
      this.form.email = "";
      this.form.phone_number = "";
      this.form.corporate_name = "";
      this.form.category = "";
      this.form.web_url = "";
      this.form.job_pic = "";
    },
    duplicateOcupation1() {
      this.ocupation1 = this.ocupation1.concat(
        this.ocupation1,
        this.ocupation1,
        this.ocupation1
      );
    },
    duplicateOcupation2() {
      this.ocupation2 = this.ocupation2.concat(
        this.ocupation2,
        this.ocupation2,
        this.ocupation2
      );
    },
    duplicateOcupation3() {
      this.ocupation3 = this.ocupation3.concat(
        this.ocupation3,
        this.ocupation3,
        this.ocupation3
      );
    },
  },
  mounted() {
    this.getClientLogo();
    this.getFaq();
    this.duplicateOcupation1();
    this.duplicateOcupation2();
    this.duplicateOcupation3();
  },
};
</script>

<style src="./index.css" scoped></style>